<cc-settings-block>
  <cc-settings-header
    header="MAPPING.HEADER">
    <span translate="MAPPING.ACTIVE" *ngIf="!active"></span>
    <span translate="MAPPING.INACTIVE" *ngIf="active"></span>
    <ui-switch
      [disabled]="active"
      [checked]="!!(showBlock || callerType)"
      (change)="toggleShowBlock()"
      class="custom"></ui-switch>
  </cc-settings-header>

  <cc-settings-footer
    *ngIf="active"
    body="MAPPING.INACTIVE_DESCRIPTION">
  </cc-settings-footer>

  <div *ngIf="!active">
    <cc-settings-body *ngIf="showBlock || callerType">

      <div class="items-wrapper w-100 d-flex justify-content-center align-item-center"
           [ngClass]="{'justify-content-center': !isMultiSelect}">

        <div class="left-item-wrapper d-flex justify-content-center align-item-center p-y-2 flex-wrap flex-direction-column"
             [ngClass]="{'flex-one': isMultiSelect}">

            <cc-mapping-item-header></cc-mapping-item-header>

            <div class="w-100 d-flex justify-content-center">
              <cc-mapping-item

                class="flex-one"
                [callerType]="'shuffle'"
                [classState]="isShuffle"
                [iconUrl]="'/assets/img/baseline-shuffle-24px.svg'"
                [title]="'MAPPING.SHUFFLE'"
                (changeCallerType)="selectType($event)"
              >
              </cc-mapping-item>

              <cc-mapping-item
                class="flex-one"
                [callerType]="'multiselect'"
                [classState]="isMultiSelect"
                [iconUrl]="'/assets/img/baseline-add_box-24px.svg'"
                [title]="'MAPPING.MULTISELECT'"
                (changeCallerType)="selectType($event)"
              >
              </cc-mapping-item>

            </div>

          </div>

          <div class="item-wrapper flex-six max-w-100-percent"
               [ngClass]="isMultiSelect ? 'd-block': 'none'">

            <cc-mapping-row class="p-y-1 p-x-2 grey-300">
              <div translate>MAPPING.TABLE_HEADER_1</div>
              <div translate>MAPPING.TABLE_HEADER_2</div>
            </cc-mapping-row>

            <cc-mapping-row class="p-x-2">

              <cc-mapping-detect-prefix
                class="flex-2 m-r-1"
                [form]="mappingForm.controls[0]"
              ></cc-mapping-detect-prefix>

              <cc-mapping-assigned-number
                [editMode]="true"
                class="flex-3"
                [form]="mappingForm.controls[0]"
                (changed)="addMapping(mappingForm.controls[0])"
                [msisdns]="msisdnsList"
              ></cc-mapping-assigned-number>

            </cc-mapping-row>

            <div class="flex-container p-x-2 d-flex justify-content-start w-100" *ngFor="let form of mappingForm.controls | slice: 1">

              <cc-mapping-country-code
                class="flex-2 p-y-2 m-r-1"
                [form]="form"
                [editMode]="editMode[form.get('id').value]">
              </cc-mapping-country-code>
              <cc-mapping-assigned-number
                class="flex-3 p-y-2"
                [editMode]="editMode[form.get('id').value]"
                [form]="form"
                (changeEditMode)="onChangeEditMode(form.get('id').value)"
                (delete)="onDelete(form.get('id').value)"
                (changed)="editMapping(form)"
                [msisdns]="msisdnsList"
              ></cc-mapping-assigned-number>

            </div>

          </div>
      </div>

    </cc-settings-body>
  </div>

  <div *ngIf="(showBlock || callerType) && !active">

    <cc-mapping-description
      *ngIf="isShuffle || !callerType"
    [classState]="isShuffle"
    [title]="'MAPPING.SHUFFLE'"
    [description]="'MAPPING.SHUFFLE_DESCRIPTION'">
    </cc-mapping-description>

    <cc-mapping-description
      class="block b-t"
      *ngIf="isMultiSelect || !callerType"
      [classState]="isMultiSelect"
      [title]="'MAPPING.MULTISELECT'"
      [description]="'MAPPING.MULTISELECT_DESCRIPTION'">
    </cc-mapping-description>

  </div>

</cc-settings-block>
